import { type ReactElement } from 'react'
import { type FocusRow } from '../types'
import { RowOverflowNode } from './RowOverflowNode'
import { TeamNode } from './node'

export const TeamFocusRow = ({ row }: { row: FocusRow }): ReactElement => {
  return (
    <div className='p-2xl flex min-h-[120px] flex-row items-start justify-center gap-8'>
      {row.teams.map((team) => (
        <TeamNode key={team.teamId} team={team} />
      ))}
      {row.overflowCount > 0 && <RowOverflowNode row={row} />}
    </div>
  )
}
